import React from 'react'
import { Select } from 'antd'
import { useFetchConceptualLabelsQuery } from '../../../../store/apis/conceptual-label.api'

const ConceptualLabelSelectParent = ({ value, onChange }) => {
    const { data: parentLabels, isFetching } = useFetchConceptualLabelsQuery(
        { includeSuggested: false }
    )
    return (
        <Select
            placeholder="Select a parent label (optional)"
            value={value}
            onChange={onChange}
            loading={isFetching}
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {parentLabels?.map(label => (
                <Select.Option key={label.id} value={label.id}>
                    {label.name}
                </Select.Option>
            ))}
        </Select>
    )
}

export default ConceptualLabelSelectParent 